export const ABOUT_META = [
    { label: 'Founded', value: '2014' },
    { label: 'Base', value: 'London SE1' },
    { label: 'Disciplines', value: 'Landscape, aerial' },
    { label: 'Editions', value: 'Twelve per work' }
]

export const ABOUT_METHOD = [
    {
        index: '01',
        title: 'Reconnaissance',
        body: 'We arrive days before we shoot. Tide tables, sun angles, and a great deal of walking. By the time a camera comes out of the bag we already know where we will be standing and at what hour.'
    },
    {
        index: '02',
        title: 'The wait',
        body: 'Most of the work is waiting for four minutes of light that may never arrive. Alpenglow, 06:14 took eleven days on a headland in Lofoten. We came home with one frame and it was the right one.'
    },
    {
        index: '03',
        title: 'One frame',
        body: 'No brackets, no composites, no borrowed skies. What the negative holds is what the print holds. It keeps the archive honest, and it means a collector is buying a moment rather than an assembly.'
    },
    {
        index: '04',
        title: 'The print',
        body: 'Every edition is drum-scanned, printed on cotton rag at up to 1.4 metres, signed, numbered to twelve, and shipped flat in a crate built for it. The print is the work. Everything before it is preparation.'
    }
]

export const ABOUT_PLATES = [
    {
        src: '/images/about/camera.png',
        alt: 'A lone figure walking a ridge line between pale and rust-coloured hills',
        caption: 'Reconnaissance · Day four',
        span: 'md:col-span-5 md:col-start-1',
        ratio: 'aspect-[4/5]',
        parallax: '54'
    },
    {
        src: '/images/about/darkroom.png',
        alt: 'A hand holding a set of small monochrome landscape prints',
        caption: 'Edit table · Bermondsey',
        span: 'md:col-span-4 md:col-start-8 md:mt-[2.5vh]',
        ratio: 'aspect-[3/4]',
        parallax: '78'
    },
    {
        src: '/images/about/gallery.png',
        alt: 'A visitor standing in front of large monochrome photographs in a gallery',
        caption: 'Cold Archive · Kunsthal, Rotterdam',
        span: 'md:col-span-7 md:col-start-3 md:mt-[1.5vh]',
        ratio: 'aspect-[16/10]',
        parallax: '44'
    }
]

export const ABOUT_NOTE = {
    label: 'Notebook',
    body: '"Fogbank held from four until nine. We shot the last eleven minutes and none of the first four hours."',
    credit: '— field log, Lofoten'
}

export const ABOUT_INDEX = [
    { year: '2025', kind: 'Exhibition', title: 'Cold Archive', venue: 'Kunsthal, Rotterdam' },
    { year: '2024', kind: 'Festival', title: 'Edgewater', venue: 'Format, Derby' },
    { year: '2024', kind: 'Commission', title: 'Coastal survey', venue: 'Norwegian Coastal Administration' },
    { year: '2023', kind: 'Exhibition', title: 'From Above', venue: 'Aperture, New York' },
    { year: '2022', kind: 'Group show', title: 'Distance Study', venue: 'The Photographers Gallery, London' },
    { year: '2021', kind: 'Commission', title: 'Shoreline programme', venue: 'National Trust' }
]
